<template>
  <div class="panel panel-left events-contact" :class="{ 'hidden': !visible }">
    <div class="events-container" v-bar="{ preventParentScroll: true, overrideFloatingScrollbar: false }" :style="{ display: contactVisible ? 'none' : 'block' }">
      <div>
        <div ref="upcoming" class="upcoming" :style="{ marginTop: `calc(50vh - ${upcomingHeight+30}px)` }" v-if="upcomingEvents && upcomingEvents.length">
          <strong>Upcoming</strong><br>
          <div v-for="event in upcomingEvents" :key="event.id" class="event">
            {{ event.date }}
            <br>
            {{ event.description }}
          </div>
        </div>
        <div ref="past" class="past" :style="{ marginTop: !upcomingEvents || !upcomingEvents.length ? `calc(50vh - ${Math.min(pastHeight+30, maxHeight)}px)` : '0' }" v-if="pastEvents && pastEvents.length">
          <strong>Past</strong><br>
          <div v-for="event in pastEvents" :key="event.id" class="event">
            {{ event.date }}
            <br>{{ event.description }}
          </div>
        </div>
      </div>
    </div>
    <div class="contact-container" :style="{ display: contactVisible ? 'block' : 'none' }">
      <div class="" v-html="contact"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

const formatOptions = {
  weekday: "numberic",
  year: "numeric",
  month: "short",
  day: "numeric"
};

export default {
  data() {
    return {
      upcomingHeight: 0,
      pastHeight: 0,
      maxHeight: IS_SERVER ? 0 : document.documentElement.clientHeight * .5
    }
  },
  computed: {
    ...mapState({
      visible: state => !!state.panels.left.visible,

      upcomingEvents: state => state.events.upcoming,
      pastEvents: state => state.events.past,

      contact: state => state.contact,

      eventsVisible: state => state.panels.left.content === 'events',
      contactVisible: state => state.panels.left.content === 'contact'
    })
  },
  methods: {
    onResize(e) {
      this.maxHeight = document.documentElement.clientHeight * .5
    }
  },
  mounted() {
    this.upcomingHeight = this.$refs.upcoming ? this.$refs.upcoming.offsetHeight : 0,
    this.pastHeight = this.$refs.past ? this.$refs.past.offsetHeight : 0

    if (!IS_SERVER)
      window.addEventListener('resize', this.onResize)
  },
  unmounted() {
    if (!IS_SERVER)
      window.removeEventListener('resize', this.onResize)
  }
};
</script>
